/**
 * The leverage field while the trader types.
 *
 * `text` is what the field shows: the leading whole number only, so a cleared
 * field stays empty instead of snapping to 1 (which turned typing "5" into "15"),
 * and a pasted "2.5" reads as 2 rather than having its digits joined into 25.
 * `leverage` is that whole number clamped to 1..max, or `undefined` while the
 * field holds no digits.
 */
export const parseLeverageInput = (
  raw: string,
  maxLeverage: number
): { text: string; leverage: number | undefined } => {
  const text = /^\d*/.exec(raw.trim())?.[0] ?? "";
  if (text === "") return { text, leverage: undefined };
  const upper = Math.max(1, Math.floor(maxLeverage) || 1);
  return { text, leverage: Math.max(1, Math.min(Number(text), upper)) };
};
